import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { Mail, ArrowUpRight } from "lucide-react";
import { BRAND } from "../lib/brand";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#0F172A] py-16 text-white"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
          <div className="[&_*]:!text-white">
              <Logo textColor="text-white" subColor="text-white/60" />
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/65">
              Comprehensive Professional Solutions Consulting — convening capital,
              expertise and stakeholders for execution at scale.
            </p>
          </div>
          <div>
            <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-white/60">
              Explore
            </p>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <a href="/#about" className="text-white/85 hover:text-[#00A3E0]">
                  About Us
                </a>
              </li>
              <li>
                <a href="/#services" className="text-white/85 hover:text-[#00A3E0]">
                  Our Services
                </a>
              </li>
              <li>
                <a href="/#sectors" className="text-white/85 hover:text-[#00A3E0]">
                  Sectors
                </a>
              </li>
              <li>
                <a href="/#contact" className="text-white/85 hover:text-[#00A3E0]">
                  Contact
                </a>
              </li>
            </ul>
          </div>
          <div>
            <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-white/60">
              Sectors
            </p>
            <ul className="mt-4 space-y-2 text-sm">
              <li className="text-white/85">Energy</li>
              <li className="text-white/85">Real Estate</li>
              <li className="text-white/85">Infrastructure</li>
              <li className="text-white/85">Commodities</li>
              <li className="text-white/85">Media & Communications</li>
            </ul>
          </div>
          <div>
            <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-white/60">
              Get in touch
            </p>
            <a
              href={`mailto:${BRAND.email}`}
              className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-white hover:text-[#00A3E0]"
            >
              <Mail className="h-4 w-4" />
              {BRAND.email}
            </a>
            <Link
              to="/submit-project"
              data-testid="footer-submit-cta"
              className="mt-5 inline-flex items-center gap-2 rounded-full bg-[#00A3E0] px-5 py-3 text-sm font-semibold text-white hover:bg-[#0089bd]"
            >
              Submit a project <ArrowUpRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
        <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-white/55">
            © {new Date().getFullYear()} {BRAND.name}. All rights reserved.
          </p>
          <p className="text-xs text-white/55">
            Designed for the consortium economy.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
